import { defineElement } from '@webtides/element-js';
import style from './color-button.css';
import BaseColorButton from '@zeg/base-light-module/frontend/components/elements/color-button/color-button.class';

class ColorButton extends BaseColorButton {
    styles() {
        return [style];
    }
}

defineElement('color-button', ColorButton);
